import { API } from "@/lib/api";

/* ------------------------------------------------------------------
   Streams one assistant turn over SSE (fetch + ReadableStream so the
   Authorization header can be set). Calls onEvent for every parsed
   `data:` line. Resolves when the server closes the stream.
   ------------------------------------------------------------------ */
export async function streamMessage({ convId, content, context, signal, onEvent }) {
  const token = localStorage.getItem("ke_token");
  const res = await fetch(`${API}/drift/ai/conversations/${convId}/messages`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "text/event-stream", Authorization: `Bearer ${token}` },
    body: JSON.stringify({ content, context: context ? { type: context.type, id: context.id } : null }),
    signal,
  });
  if (!res.ok) {
    let detail = "Assistenten svarte ikkje.";
    try {
      const j = await res.json();
      if (typeof j?.detail === "string") detail = j.detail;
    } catch { /* ignore */ }
    const err = new Error(detail);
    err.status = res.status;
    throw err;
  }
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  const flush = (chunk) => {
    for (const line of chunk.split("\n")) {
      if (!line.startsWith("data: ")) continue;
      try { onEvent(JSON.parse(line.slice(6))); } catch { /* skip malformed */ }
    }
  };
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    let idx;
    while ((idx = buf.indexOf("\n\n")) >= 0) {
      flush(buf.slice(0, idx));
      buf = buf.slice(idx + 2);
    }
  }
  if (buf.trim()) flush(buf);
}

/* Download a text blob as a file. */
export function downloadText(filename, text) {
  const blob = new Blob([text], { type: "text/markdown;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 500);
}

export const slugFile = (title) => (title || "dokument").toLowerCase().replace(/[^a-z0-9æøå]+/gi, "-").replace(/^-+|-+$/g, "").slice(0, 60) || "dokument";
